"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatekeeperSignupParamKeys = exports.GatekeeperPage = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var ResetPassword_1 = __importDefault(require("./ResetPassword/ResetPassword"));
var Login_1 = __importDefault(require("./Login/Login"));
var Signup_1 = __importDefault(require("./Signup/Signup"));
var StanfordLogin_1 = __importDefault(require("./Login/StanfordLogin"));
var SetNewPassword_1 = __importDefault(require("./SetNewPassword/SetNewPassword"));
var Navigation_1 = require("./Navigation/Navigation");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LoginOnly_1 = __importDefault(require("./Login/LoginOnly"));
var Utils_1 = require("Utils/Utils");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var GatekeeperPage;
(function (GatekeeperPage) {
    GatekeeperPage["Signup"] = "signup";
    GatekeeperPage["Login"] = "login";
    GatekeeperPage["LoginOnly"] = "loginOnly";
    GatekeeperPage["StanfordLogin"] = "loginStanford";
    GatekeeperPage["ResetPassword"] = "resetPassword";
    GatekeeperPage["SetNewPassword"] = "setNewPassword";
})(GatekeeperPage || (exports.GatekeeperPage = GatekeeperPage = {}));
var GatekeeperSignupParamKeys;
(function (GatekeeperSignupParamKeys) {
    GatekeeperSignupParamKeys["EntryPoint"] = "entry_point";
    GatekeeperSignupParamKeys["WithTemplate"] = "with_template";
    GatekeeperSignupParamKeys["WithPage"] = "with_page";
    GatekeeperSignupParamKeys["InviteHash"] = "invite_hash";
    GatekeeperSignupParamKeys["InviteAccount"] = "invite_account";
    GatekeeperSignupParamKeys["AuthenticationMethods"] = "authentication_methods";
    GatekeeperSignupParamKeys["Plan"] = "plan";
})(GatekeeperSignupParamKeys || (exports.GatekeeperSignupParamKeys = GatekeeperSignupParamKeys = {}));
var Gatekeeper = (0, mobx_react_1.observer)(function (props) {
    var commonProps = {
        publicApiBaseUrl: QwilrConfig.publicApiBaseUrl,
        allowDevAutocomplete: props.allowDevAutocomplete,
    };
    var urlSearchParams = (0, Utils_1.getParamsFromAngularUrl)(document.location.href);
    var renderPage = function () {
        switch (props.page) {
            case GatekeeperPage.Signup:
                var entryPoint = urlSearchParams.get(GatekeeperSignupParamKeys.EntryPoint);
                var inviteHash = urlSearchParams.get(GatekeeperSignupParamKeys.InviteHash);
                var inviteAccount = urlSearchParams.get(GatekeeperSignupParamKeys.InviteAccount);
                var authenticationMethods = urlSearchParams.get(GatekeeperSignupParamKeys.AuthenticationMethods);
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Navigation_1.SignupNavigation, null),
                    react_1.default.createElement(Signup_1.default, __assign({}, commonProps, { entryPoint: entryPoint, inviteHash: inviteHash, inviteAccount: inviteAccount, authenticationMethods: authenticationMethods, onComplete: props.gatekeeperApiService.signup })),
                    react_1.default.createElement("div", { className: "gatekeeper__disclaimer" },
                        "Signing up for a Qwilr account means you agree to our",
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/privacy" }, "Privacy Policy"),
                        " and",
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/terms" }, "Terms of Service"),
                        ".")));
            case GatekeeperPage.LoginOnly:
                var source = urlSearchParams.get("source");
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(LoginOnly_1.default, __assign({}, commonProps, { source: source, onComplete: props.gatekeeperApiService.login }))));
            case GatekeeperPage.Login:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Navigation_1.LoginNavigation, null),
                    react_1.default.createElement(Login_1.default, __assign({}, commonProps, { onComplete: props.gatekeeperApiService.login }))));
            case GatekeeperPage.StanfordLogin:
                return react_1.default.createElement(StanfordLogin_1.default, __assign({}, commonProps));
            case GatekeeperPage.ResetPassword:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Navigation_1.LoginNavigation, null),
                    react_1.default.createElement(ResetPassword_1.default, __assign({}, commonProps, { onComplete: function (email) { return props.gatekeeperApiService.resetPassword({ email: email }); } }))));
            case GatekeeperPage.SetNewPassword:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Navigation_1.LoginNavigation, null),
                    react_1.default.createElement(SetNewPassword_1.default, __assign({}, commonProps, { onComplete: props.gatekeeperApiService.setNewPassword }))));
            default:
                return null;
        }
    };
    return react_1.default.createElement("div", { className: tokens_1.lightTheme }, renderPage());
});
exports.default = Gatekeeper;
